import React, { Fragment } from 'react';
import CSSReset from './static/styles/cssReset';
require('prism-themes/themes/prism-material-dark.css');

export const wrapRootElement = ({ element }) => (
  <Fragment>
    <CSSReset />
    {element}
  </Fragment>
);
